// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Ju-z","play":"Ku-z"};